var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.1,
    height: 36.1,
    viewBox: "0 0 36.1 36.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "task_2",
    "data-name": "task 2",
    d: "M325.3,385.73H303.64a7.218,7.218,0,0,0-7.22,7.22v21.66a7.218,7.218,0,0,0,7.22,7.22H325.3a7.23,7.23,0,0,0,7.22-7.22V392.95A7.23,7.23,0,0,0,325.3,385.73Zm-10.83,9.025H323.5a1.8,1.8,0,1,1,0,3.61H314.47a1.8,1.8,0,1,1,0-3.61Zm10.83,9.025a1.81,1.81,0,0,1-1.805,1.805H318.08a1.805,1.805,0,0,1,0-3.61H323.5A1.8,1.8,0,0,1,325.3,403.78Zm-19.638,4.26-2.563-2.545c-.018-.018-.018-.036-.036-.054a1.8,1.8,0,0,1,.036-2.545,1.836,1.836,0,0,1,2.563.036l1.263,1.281,3.845-3.827a1.8,1.8,0,1,1,2.545,2.545l-5.108,5.108A1.8,1.8,0,0,1,305.662,408.04Zm8.808,4.765a1.805,1.805,0,0,1,0-3.61H323.5a1.805,1.805,0,1,1,0,3.61Z",
    transform: "translate(-296.42 -385.73)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/taskIcon.8d0985d8cda25b544ab5fe4073df2b15.svg";
export { ForwardRef as ReactComponent };